import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { QuickNotesService } from '../services/quick-notes.service';
export const useQuickNotesStore = create()(persist((set) => ({
    content: '',
    isLoading: false,
    isSaving: false,
    error: null,
    setContent: (content) => {
        set({ content });
    },
    loadNote: async (userId) => {
        set({ isLoading: true, error: null });
        try {
            const note = await QuickNotesService.getNote(userId);
            if (note) {
                set({ content: note.content, isLoading: false });
            }
            else {
                // No existing note, keep default
                set({ isLoading: false });
            }
        }
        catch (error) {
            console.error('Failed to load note:', error);
            set({
                error: error instanceof Error ? error.message : 'Failed to load note',
                isLoading: false,
            });
        }
    },
    updateNote: async (content, userId) => {
        set({ content, isSaving: true, error: null });
        try {
            const success = await QuickNotesService.saveNote(userId, content);
            if (success) {
                set({ isSaving: false });
            }
            else {
                set({
                    error: 'Failed to save note',
                    isSaving: false,
                });
            }
        }
        catch (error) {
            console.error('Failed to save note:', error);
            set({
                error: error instanceof Error ? error.message : 'Failed to save note',
                isSaving: false,
            });
        }
    },
}), {
    name: 'quick-notes-storage',
}));
